<template>
  <div>
    <div class="title" :style="isNotLogin?'':{backgroundColor: '#044995', color: '#fff'}">
      <div class="left-content" :style="isNotLogin?'':{color: '#fff'}">
        长沙县卫生健康局局长信箱
      </div>
      <div v-if="isNotLogin" class="breadcrumb">
        <!-- <span>
          <el-badge :value="0" class="item" type="success">
            <i class="el-icon-bell" style="font-size: 18px;"></i>
          </el-badge>
        </span> -->
        <div class="boxarea end">
          <el-dropdown>
            <span class="el-dropdown-link">
              <span class="boxarea-img">
                <i class="el-icon-user"></i>
              </span>
              个人中心<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <span @click="logout">退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    
    <div class="title-btn-box" v-if="isNotLogin">
      <div class="title-name">{{ this.$route.meta.name }}</div>
      <!-- <div class="logout-box" @click="logout">
        退出
      </div> -->
      <div>
        <el-button class="tbtn" style="background-color: #FE9857;"  type="warning" round @click="toRoutePath('mailbox')">
          <img class="header-icon" src="../../assets/images/header-btn-write.png" />
          我要写信
        </el-button>
        <el-button class="tbtn" style="background-color: #2066DC;border-color: #2066DC;"  type="primary" round @click="toRoutePath('client')">
          <img class="header-icon" src="../../assets/images/header-btn-read.png" />
          我要查信
        </el-button>
      </div>
    </div>

    <div class="content" :style="isNotLogin?'':{backgroundColor: '#F9F9F9'}">
      <slot></slot>
    </div>
  </div>
</template>

<script>

export default {
    data() {
        return {

        }
    },
    props: {
        isNotLogin: {
            type: Boolean,
            default: true
        }
    },
    mounted() {
    },
    methods: {
      toRoutePath(rout) {       
        if(this.$route.name == rout){
            // this.$router.go(0)
        }else {
            this.$router.push(rout)
        }
      },
      // 退出登录
      logout() {
        this.$store.dispatch('LogoutAction')
        this.$router.replace('/')
      }
    }
}

</script>

<style lang="scss" scoped>
// 根据宽度，跳转头部样式
$screenDiff-width: 800px;

.title {
    background: #044995;
    color: #FFFFFF;
    height: 0.88rem;
    
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media screen and (min-width: $screenDiff-width) {
      background-color:#FFFFFF;
      color: #373D47;
      height: 62px;
      box-shadow: 0px 0px 6px 0px rgba(200,206,214,0.3);
    }

    .left-content {
      margin-left: 0.28rem;
      height: 0.39rem;
      font-size: 0.28rem;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;

      @media screen and (min-width: $screenDiff-width) {
        margin-left: 17px;
        height: 30px;
        font-size: 24px;
        font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
        font-weight: 400;
        color: #373D47;
      }
    }
    .breadcrumb {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #93A3BA;
      @media screen and (max-width: $screenDiff-width) {
        display: none;
      }

      .boxarea {
        width: 100px;
        margin-left: 10px;
        border-radius: 15px;
        background-color: rgb(246,246,246);
        padding: 4px 2px;
        height: 20px;

        display: flex;
        align-items: center;
        .el-dropdown-link {
          letter-spacing: 2px;
          font-size: 10px;
        }
      }
      .end {
        margin-right: 25px;
      }
    }
}

.title-btn-box{
  background-color: #044995;
  height: 48px;
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media screen and (max-width: $screenDiff-width) {
    background-color:#fff;
  }
  div {
    padding: 5px;
    color: #fff;
    font-size: 20px;
  }
  .title-name {
    margin-left: 10px;
    @media screen and (max-width: $screenDiff-width) {
      display: none;
    }
  }
  .tbtn {
    width: 124px; 
    height: 32px; 
    @media screen and (max-width: $screenDiff-width) {
      width: 90px;
    }
  }
  /deep/ .el-button.is-round {
    padding: 0;
  }

  .logout-box {
    color: #fff;
    background: #fb6359;
    border-radius: 20px;
    font-size: 14px;
    width: 70px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    @media screen and (min-width: $screenDiff-width) {
      display: none;
    }
  }
  .header-icon {
    width: 15px;
  }
}

.content {
  height: calc(100vh - 0.88rem);
  overflow: auto;
  // background-color: #F9F9F9;

  @media screen and (min-width: $screenDiff-width) {
    height: calc(100vh - (62px + 48px + 16px + 16px));  
    margin: auto; 
    background-color: #fff;
  }
}
</style>